<template>
    <div>
        <Mainlayout></Mainlayout>
    
        <CCol sm="12" class="bg-0A1129">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;color: #fff" class="d-sm-down-none">
                <br /> <br />
                <CRow class="m-2">
    
                    <CCol sm="6">
                        <CCard class="bg-101C46 mt-5 b-20 custom-line-border">
                            <section class="why-section py-5 text-center text-light">
    
                                <div class="spotlight-container">
                                    <div class="spotlight">
                                       
                                    </div>
                                    <h1 class="custom-header-title text-white text-left text-48px">
                                            <strong>Hubungi kami</strong>
                                        </h1>
                                        <label class="custom-header-subtitle text-left p-40 text-white">Apa kata pelajar yang telah berjaya menjadi profesional selepas belajar bersama kami</label>
                                </div>
                            </section>
    
                            <CRow class="p-40 mb-20">
                                <CCol sm="2"><img style="max-width:100%" src="../assets/img/flyhigh/mail.png" /></CCol>
                                <CCol sm="10">
                                    <h4 class="custom-14px-400 font-color-A3A3A3">General Enquiries</h4>
                                    <h5 class="text-white mt-2">adm.flyhigh@gmail.com</h5>
                                </CCol>
    
    
                                <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/flyhigh/phone-circle.png" /></CCol>
                                <CCol sm="10" class="mt-2">
                                    <h4 class="custom-14px-400 font-color-A3A3A3">Phone</h4>
                                    <h5 class="text-white mt-2">+601135546900</h5>
                                </CCol>
    
                                <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/flyhigh/map.png" /></CCol>
                                <CCol sm="10" class="mt-2">
                                    <h4 class="custom-14px-400 font-color-A3A3A3">Office</h4>
                                    <h5 class="text-white mt-2">109, 11, Judo 13/45
Seksyen 13
40100 Shah Alam
Selangor Darul Ehsan

</h5>
                                </CCol>
    
                            </CRow>
                            <br /><br />
                        </CCard>
                    </CCol>
                    <CCol sm="6">
                        <CCard class="gradient-box mt-5 p-40 b-20" style="border:none">
                            <label class="text-white mt-3">Nama</label>
                            <input type="text" class="custom-input-app b-50" v-model="Name" />
    
                            <label class="text-white">Emel</label>
                            <input type="text" class="custom-input-app b-50" v-model="Email" />
    
                            <label class="text-white">Nombor Telefon</label>
                            <input type="text" class="custom-input-app b-50" v-model="Phone" />
    
                            <label class="text-white">Mesej</label>
                            <CTextarea type="text" rows="9" v-model="Help" />

                            <span class="d-flex"><input type="checkbox" class="ml-3"/>Anda bersetuju dengan polisi privasi kami.</span>
                            <div class="text-right mb-5 mt-3">
                                <CButton class="bg-white font-color-1A1A1A" block><span class="ml-2 mr-2" @click="insertHelp()">Hantar Mesej</span></CButton>
                            </div>
    
                        </CCard>
                    </CCol>
                </CRow>
                <br /> <br />
            </CCol>
    
          
    
        </CCol>
    
      
        <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 100px" src="../assets/img/rightstar.png" />
                    <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Thank you for submitting the form</h3>
                    <h3 class="custom-16px-400 text-center">
                        We are carefully reviewing your request and will notify you of the results within the next 2 days.
                    </h3>
    
                </div>
    
                <CButton class="custom-border-purple text-white" @click="closePopup1()" block><span class="ml-2 mr-2">Close</span></CButton>
    
            </div>
        </div>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../components/Footer.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isLanguagePopupVisible2: false,
            Name: "",
            Email: "",
            Phone: "",
            Help: "",

            Names: "",

        };
    },
    created() {},
    mounted() {
        // const isAuth = this.UserAuth();
        //     if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
        // }
    },
    methods: {
        insertHelp() {
            const formData = new FormData();
            formData.append("name", this.Name);
            formData.append("email", this.Email);
            formData.append("phone", this.Phone);
            formData.append("help", this.Help);


            this.$API
                .post(this.$RegisterSupport, formData, )
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.isLanguagePopupVisible2 = true;
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {


                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });

        },
        closePopup1() {
            this.isLanguagePopupVisible2 = false
            this.$router.push("/");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("ContactUs");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("ContactUs");
                console.error("Error fetching user info:", error);
            }
        },
    }

};
</script>
